export enum CpdCategoryEnum {
    AccreditedContinuedEducationCEActivity = "EXT",
    AnnualPlan = "PDP",
    Audit = "AUD",
    External = "EXTLEG",
    Internal = "INT",
    PersonalLearning = "PER",
    PracticeReview = "PR",
    ResearchOrTraining = "RES",
    WorkBasedLearning = "WBL"
}